const DAY_SHORT = {
  0: 'Paz',
  1: 'Pzt',
  2: 'Sal',
  3: 'Çar',
  4: 'Per',
  5: 'Cum',
  6: 'Cmt',
};

export function getCampaignType(campaign) {
  return campaign?.campaignType || 'coupon';
}

export function formatCampaignDiscount(campaign) {
  const type = campaign?.discountType || 'percentage';
  if (type === 'menom_coins') {
    const coins = campaign?.menomCoinsReward ?? campaign?.discountValue ?? 0;
    return coins > 0 ? `+${coins} Menom Coin` : 'Menom Coin ödülü';
  }
  const value = campaign?.discountValue ?? campaign?.discount;
  if (value == null || value === '') return '—';
  if (type === 'fixed_amount') return `${value} ₺ indirim`;
  if (type === 'fixed_price') return `${value} ₺ sabit fiyat`;
  return `%${value}`;
}

export function formatCampaignTypeLabel(campaign) {
  return getCampaignType(campaign) === 'automatic' ? 'Otomatik' : 'Kupon';
}

export function formatCampaignCode(campaign) {
  if (getCampaignType(campaign) === 'automatic') {
    return 'Kod yok (menüde uygulanır)';
  }
  return campaign?.code || '—';
}

export function formatCampaignSchedule(campaign) {
  const scheduleType = campaign?.scheduleType || 'date_range';
  if (scheduleType !== 'recurring') {
    return 'Tarih aralığı';
  }
  const rec = campaign?.recurrence || {};
  const days = (rec.daysOfWeek || [])
    .slice()
    .sort((a, b) => a - b)
    .map((d) => DAY_SHORT[d] ?? d)
    .join(', ');
  if (!days) return 'Tekrarlayan';
  if (rec.allDay) return `${days} · Tüm gün`;
  const start = rec.startTime || '00:00';
  const end = rec.endTime || '23:59';
  return `${days} · ${start}–${end}`;
}

export function countScopeIds(ids) {
  if (!ids) return 0;
  if (!Array.isArray(ids)) return 0;
  return ids.filter((id) => id != null && id !== '').length;
}

export function formatCampaignScope(campaign) {
  const scopeType = campaign?.scopeType || 'all';
  if (scopeType === 'categories') {
    const n = countScopeIds(campaign?.scopeCategoryIds);
    return n > 0 ? `${n} kategori` : 'Seçili kategoriler';
  }
  if (scopeType === 'products') {
    const n = countScopeIds(campaign?.scopeProductIds);
    return n > 0 ? `${n} ürün` : 'Seçili ürünler';
  }
  return 'Tüm menü';
}

export function formatCampaignMinOrder(campaign) {
  const min = campaign?.minOrderAmount;
  if (min == null || min === '' || Number(min) <= 0) return null;
  return `Min. sepet: ${Number(min)} ₺`;
}

export function formatCampaignPeriod(campaign, dayjs) {
  if (!campaign?.startDate || !campaign?.endDate) return '—';
  const start = dayjs(campaign.startDate).format('DD.MM.YYYY');
  const end = dayjs(campaign.endDate).format('DD.MM.YYYY');
  return `${start} – ${end}`;
}
